var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.stringValue,
        expression: "stringValue",
      },
    ],
    staticClass: "form-control",
    class: { "is-invalid": _vm.isInvalid },
    attrs: {
      name: _vm.name,
      min: _vm.minDateStr,
      max: _vm.maxDateStr,
      required: "required",
      size: "16",
      type: "date",
      disabled: !_vm.enabled,
      readonly: _vm.usedFallback,
    },
    domProps: { value: _vm.stringValue },
    on: {
      input: function ($event) {
        if ($event.target.composing) return
        _vm.stringValue = $event.target.value
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }